import { render, staticRenderFns } from "./EditUniverseButton.vue?vue&type=template&id=90e3279a&scoped=true&"
import script from "./EditUniverseButton.vue?vue&type=script&lang=js&"
export * from "./EditUniverseButton.vue?vue&type=script&lang=js&"
import style0 from "./EditUniverseButton.vue?vue&type=style&index=0&id=90e3279a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e3279a",
  null
  
)

export default component.exports